import {
  Component,
  HostBinding,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { AbstractAttendanceTimelineDirective } from '@directives/abstract-attendance-timeline.directive';
import { EventService } from '@services/event-service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Anomaly } from 'src/app/queries/generated';

@Component({
  selector: 'lv-attendance-timeline-anomaly',
  styleUrls: ['attendance-timeline-anomaly.component.scss'],
  template: '',
  encapsulation: ViewEncapsulation.None
})
/// ESLintCircularFixesWarning: Circular fixes detected while fixing here.
// eslint-disable-next-line
export class AttendanceTimelineAnomalyComponent extends AbstractAttendanceTimelineDirective implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<EventService>();
  private events = inject(EventService);

  @Input() anomaly: Anomaly;

  @HostBinding('class.is-active') selected = false;

  @HostListener('click') dispatchSelect() {
    this.events.publish('anomaly:select', this.anomaly);
  }

  ngOnInit() {
    this.events
      .of('anomaly:select')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((anomaly) => {
        this.selected = anomaly === this.anomaly;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  protected getItemTimestamp(): number {
    return new Date(this.anomaly.createdAt).getTime();
  }
}
